const initialState = {
    matchingTypes: [],
    matchingTypesForSelectionBox: [],
    matchStatusTypes: [],
    matchStatusTypesForSelectionBox: [],
    defaultFilters: [],
    defaultFiltersForSelectionBox: [],
    defaultMatchingConditions: [],
    defaultMatchingConditionsForSelectionBox: [],
    defaultFixedConditionsForSelectionBox: []
};
export default initialState;